import { Injectable } from '@angular/core';

import * as sdk from '@mycure/sdk';
import { MycureSDK } from './../service';

@Injectable({
  providedIn: 'root'
})

export class McChatService {

  constructor(
    private sdk: MycureSDK,
  ) {

  }

  async loadMessages$(query: any) {
    await this.sdk.chat.messages().find(query).watch();
  }
}
